export default {
  startLoading: 'Start loading',
  finishLoading: 'Finish loading',
  loadEditDisabled: 'Only "planned" load can be edited.',
  startLoad: 'Start load',
  confirmStartLoad: 'Start load "{load}"?',
  confirmStartLoading: 'Start loading "{load}"?',
  confirmFinishLoading: 'Finish loading "{load}"?',
};
